import React, { useContext } from "react";
import { useHistory } from "react-router-dom";

import {
  listActiveLearningPath,
  listMaterialPath,
  Context,
} from "../../../studentStore";
import SelectTextbook from "../../../templates/Select/Textbook";

export default () => {
  const { state } = useContext(Context);
  const history = useHistory();
  if (state.available_item_codes.length === 0) {
    history.push(listMaterialPath);
    return null;
  }

  return (
    <SelectTextbook
      basicPath={listMaterialPath}
      activeLearningPath={`${listActiveLearningPath}?code=${state.available_item_codes[0]}`}
      has_base={state.has_base}
    />
  );
};
